angular
	.module('WizApp')
	.service('SecurityService', [
        '$http',
        '$filter',
        'UserService',
        'PublicAccountService',
        function ($http, $filter, UserService, PublicAccountService) {
            return {
                changeEmail: function (email) {
                    var url = $filter('route')('wizbii_profileui_configuration_changeemail');
                    return $http.post(url, { email: email });
                },



                changePassword: function (data) {
                    var url = $filter('route')('wizbii_profileui_configuration_changepassword');
                    return $http.post(url, data);
                },



                setNewPassword: function (token, data) {
                    var url = $filter('route')('wizbii_onboardingui_login_lostpassword', {
                        passwordToken: token
                    });

                    return $http.post(url, {
                        'wizbii_lost_password[plainPassword][first]':   data.pass,
                        'wizbii_lost_password[plainPassword][second]':  data.repeat
                    });
                },



                resetPassword: function (email) {
                    if (typeof email !== 'string') {
                        email = UserService.Session.email;
                    }

                    return PublicAccountService.resetPassword(email);
                },

                updateEmailAlerts: function (data) {
                    var url = $filter('route')('wizbii_profileui_configuration_update_emailalerts');

                    return $http({
                        method: 'POST',
                        url,
                        data: { data }
                    });
                }
            };
        }
    ])
;
